<template>
  <scroll-view :scroll="true" class="layui">
    <template v-if="tabIndex != null">
      <template v-if="tabIndex == 0">
        <homeTemplate1></homeTemplate1>
      </template>
      <template v-if="tabIndex == 1">
        <homeTemplate2></homeTemplate2>
      </template>
      <template v-if="tabIndex == 2">
        <homeTemplate3></homeTemplate3>
      </template>
      <template v-if="tabIndex == 3">
        <homeTemplate4></homeTemplate4>
      </template>
    </template>
  </scroll-view>
</template>

<script>
import {
  AlbumgetBaseInfo,
} from '@/request/api.js'
import ability from './components/ability.vue'
import homeTemplate1 from './components/template1.vue'
import homeTemplate2 from './components/template2.vue'
import homeTemplate3 from './components/template3.vue'
import homeTemplate4 from './components/template4.vue'

export default {
  components: {
    ability,
    homeTemplate1,
    homeTemplate2,
    homeTemplate3,
    homeTemplate4
  },
  data () {
    return {
      tabIndex: null,
    }
  },
  created () {
    const param = this.$api.parseUrl()
    if (param.alias == '') {
      this.$api.Message('提示', ' 画册更新成功,请重新扫二维码进入画册')
      return
    }
    this.templateCreated()
  },
  methods: {
    async templateCreated () {
      const res = await AlbumgetBaseInfo('')
      document.title = res.data.name
      // if (res.data.template_version || res.data.template_version == 0) {
      //   alert(res.data.template_version)
      // } else {
      //   alert("template_version缺少")
      // }
      this.$store.commit('getRouter', res)
      this.$store.commit('onMenuShare', res)
      this.tabIndex = res.data.template_version
    }
  },
};
</script>

<style lang="less">
.layui {
  width: 100%;
  height: 100%;
}
</style>
